import { type ReactElement, useContext, useEffect } from 'react';
import { embedComponentsIntoContent } from 'utils/miscUtils/childrenUtils';
import type { PageType } from 'interfaces/content/articles/Post';
import { InStreamList } from 'components/Ad/AdSlot';
import { UserPaywallContext } from 'providers/PaywallProvider';
import { UserContext } from 'providers/UserProvider';

const ContentWithEmbed = ({
  children,
  embedInstructions,
  adFrequency,
  lastPWithoutAds,
  section,
  articleUrl,
  pageType,
  suppressInStreamAds = false,
  setContentRendered = () => {},
  isBranded = false,
}: {
  children: ReactElement | ReactElement[];
  embedInstructions: { node: string; index: number }[];
  adFrequency: number;
  lastPWithoutAds?: number;
  section: string;
  articleUrl: string;
  setContentRendered?: (value: boolean) => void;
  pageType?: PageType;
  suppressInStreamAds?: boolean;
  isBranded?: boolean;
}) => {
  const { paywallCheck } = useContext(UserPaywallContext).paywallState;
  const { hideInStreamAds } = useContext(UserContext);
  const renderAds = paywallCheck === 'no-paywall' && adFrequency !== 0 && !suppressInStreamAds && !hideInStreamAds;
  const content = Array.isArray(children)
    ? embedComponentsIntoContent(children[children.length - 1], children.slice(0, -1), embedInstructions)
    : embedComponentsIntoContent(children, [], embedInstructions);
  useEffect(() => {
    setContentRendered(true);
  }, [setContentRendered]);

  return (
    <InStreamList
      frequency={adFrequency}
      lastPWithoutAds={lastPWithoutAds}
      renderAds={renderAds}
      suppressInStreamAds={suppressInStreamAds}
      pageType={pageType}
      section={section}
      articleUrl={articleUrl}
      isBranded={isBranded}
    >
      {content}
    </InStreamList>
  );
};

export default ContentWithEmbed;
